import {BosToolsRole} from '../BosToolsUserType';

export class AdminUserType {
  public readonly key = 'AdminUserType';
  public readonly bosToolsRole = BosToolsRole.Admin;
}
